<template>
  <div class="payment-attempts small" v-if="ids.length">
    <div class="d-flex justify-content-between align-items-center">
      <span>
        <font-awesome-icon :icon="['far','credit-card']"></font-awesome-icon>
        Razorpay: {{ ids.length }} payment attempt(s)
        <b-badge v-if="summary" :variant="summary.variant" class="ml-1">{{ summary.text }}</b-badge>
      </span>
      <b-button size="sm" variant="link" class="p-0" @click="toggle" :disabled="loading">
        <b-spinner small v-if="loading"></b-spinner>
        <span v-else>{{ open ? 'Hide' : 'Show' }}</span>
      </b-button>
    </div>

    <b-collapse v-model="open">
      <div v-for="o of attempts" :key="o.rpOrderId" class="border-top mt-1 pt-1">
        <div class="d-flex justify-content-between text-muted">
          <code>{{ o.rpOrderId }}</code>
          <span>
            <rupee v-if="o.amount != null">{{ o.amount }}</rupee>
            <span v-if="o.createdAt"> &middot; {{ dt(o.createdAt) }}</span>
          </span>
        </div>
        <div v-if="!o.payments.length" class="text-muted font-italic">
          No payment made (checkout closed without paying)
        </div>
        <div v-for="p of o.payments" :key="p.id" class="d-flex justify-content-between align-items-start mt-1">
          <div class="mr-2">
            <b-badge :variant="variant(p.status)">{{ p.status }}</b-badge>
            <span class="text-uppercase ml-1">{{ p.method }}</span>
            <span class="text-muted"> {{ p.methodDetail }}</span>
            <div class="text-danger" v-if="p.errorDescription">
              {{ p.errorDescription }}
              <span class="text-muted" v-if="p.errorReason">({{ p.errorReason }})</span>
            </div>
          </div>
          <div class="text-right text-nowrap">
            <rupee>{{ p.amount }}</rupee>
            <div class="text-muted">{{ dt(p.createdAt) }}</div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import axios from 'axios'
import {format} from 'date-fns'
import Rupee from '@/components/rupee'

// payment attempts made on razorpay for the given razorpay order ids (failures included)
export default {
  name: 'PaymentAttempts',
  components: {Rupee},
  props: {
    ids: {type: Array, default: () => []}
  },
  data: () => ({
    open: false,
    loading: false,
    attempts: null
  }),
  computed: {
    summary() {
      if (!this.attempts) return null
      const payments = this.attempts.flatMap(o => o.payments)
      if (payments.some(p => p.captured || p.status === 'captured')) return {text: 'paid', variant: 'success'}
      if (payments.some(p => p.status === 'authorized')) return {text: 'authorized', variant: 'warning'}
      const failed = payments.filter(p => p.status === 'failed').length
      if (failed) return {text: `${failed} failed`, variant: 'danger'}
      return {text: 'not paid', variant: 'secondary'}
    }
  },
  watch: {
    ids() {
      this.attempts = null
      this.open = false
    }
  },
  methods: {
    async toggle() {
      if (!this.open && !this.attempts) {
        this.loading = true
        try {
          const {data} = await axios.get('/api/admin/razorpay/attempts', {params: {ids: this.ids.join(',')}})
          this.attempts = data.slice().reverse()
        } finally {
          this.loading = false
        }
      }
      this.open = !this.open
    },
    dt(epoch) {
      return format(new Date(epoch * 1000), 'dd MMM, hh:mm a')
    },
    variant(status) {
      return {captured: 'success', failed: 'danger', authorized: 'warning', refunded: 'info'}[status] || 'secondary'
    }
  }
}
</script>
